import { createStore } from 'vuex';
import createPersistedState from "vuex-persistedstate";
import ApplicationTab from '@/models/ApplicationTab';
import VehiclesModule from '@/store.vehicles';
import userRolesModule from './store.userRoles';
import userModule from './store.user';
import orderStatusesModule from './store.orderStatuses';
import entitiesModule from './store.entities';
import itemsModule from './store.items';

const dataState = createPersistedState({
	key: 'vuex'
});

const tabsModule = {
	state() {
		return {			
			activeTabId: null,
			navigationTabs: null,
			newlyAddedTab: null
		}
	},
	mutations: {		
		addTab(state: any, payload: ApplicationTab) {					
			if (!payload ||
				!payload.view?.length) {
				console.error(`can't add view: parameter 'payload.view' was not provided`);
				return;
			}

			const tab = new ApplicationTab(payload);

			if (!Array.isArray(state.navigationTabs)) {
				state.navigationTabs = [];
			}
			else {
				if (!tab.allowMultiple) {
					const existingTabEl = state.navigationTabs.find((_:ApplicationTab) => _.view == tab.view) as ApplicationTab | null;
					if (existingTabEl?.id) {
						existingTabEl.params = tab.params;
						state.newlyAddedTab = existingTabEl;
						state.activeTabId = existingTabEl.id;
						return;
					}
				}
			}

			const cleanNavigationTabs = state.navigationTabs.filter((_:ApplicationTab) => !!_);
			const l = cleanNavigationTabs.length;
			tab.id = l + 1;
			cleanNavigationTabs.push(tab);
			state.navigationTabs = cleanNavigationTabs;
			state.newlyAddedTab = tab;
		},

		removeTab(state: any, tabId: number) {
			if (!tabId) {
				return;
			}

			if (state.navigationTabs.length == 1) {
				state.activeTabId = null;
				state.navigationTabs = [];
				return;
			}

			const tabs = state.navigationTabs.filter((_: ApplicationTab) => _.id != tabId);	
			state.navigationTabs = tabs;
			const latestElement: ApplicationTab = state.navigationTabs[state.navigationTabs.length - 1];
			if (!latestElement?.id) {
				return;
			}

			state.activeTabId = latestElement.id;
		},

		changeTab(state: any, tabId: number) {
			if (!tabId) {
				return;
			}

			const existingTab = state.navigationTabs.find((_:ApplicationTab) => _.id == tabId) as ApplicationTab | null;
			if (!existingTab?.id) {
				return;
			}

			state.activeTabId = existingTab.id;
		}
	},
	getters: {
		/* id of an active tab */
		tab(state: any) {
			return state.activeTabId;
		},
		/** array of existing tabs on UI */
		tabs(state: any) {
			if (!state.navigationTabs?.length) {
				return [];
			}
			return state.navigationTabs.filter((_:ApplicationTab) => !!_);
		},
		/* newly added tab */
		newlyAddedTab(state: any): ApplicationTab | null {
			return state.newlyAddedTab;
		},
	}
};

const store = createStore({
	modules: {
		tabs: tabsModule,
		vehicles: VehiclesModule,
		userRoles: userRolesModule,
		orderStatuses: orderStatusesModule,
		user: userModule,
		entitiesModule: entitiesModule,
		items: itemsModule
	},
	plugins: [dataState]
});

export default store;